//@ts-nocheck

import React from "react";
import { useController } from "react-hook-form";
import type { Control } from "react-hook-form";
import type { TRule } from "@/comn/hooks";
import { useToast } from "@/comn/hooks";
import { Icon } from "../Icon";
import { getRenderedMaxLength, isWithinRawMaxLength } from "./inputLengthContract";

export type ControllerWrapperProps = TRule & {
    children: React.ReactElement;
    control?: Control;
    name?: string;
    onBlur?: any;
    onChange?: any;
    defaultValue?: any;
};

export const ControllerWrapper = (props: ControllerWrapperProps) => {
    const {
        children,
        control,
        name,
        onBlur,
        onChange,
        defaultValue,

        // rule
        min,
        max,
        minLength,
        maxLength,
        required,
        pattern,
        validate,
        copy = true,
        ...rest
    } = props;

    // msg.osc.00012

    const { showToast } = useToast();
    const mask = rest.mask;
    const renderedMaxLength = getRenderedMaxLength(maxLength, mask);
    // 마스크 길이 검증을 추가하되 화면별 함수/객체 형태의 기존 검증 규칙은 그대로 유지한다.
    const validateMaskedMaxLength = (() => {
        if (typeof maxLength !== "number" || !mask) return validate;
        const rawMaxLength = (value: any) =>
            isWithinRawMaxLength(value, maxLength, mask) || "msg.osc.00021";
        if (typeof validate === "function") {
            return (value: any) => rawMaxLength(value) === true && validate(value);
        }
        return { ...(validate || {}), rawMaxLength };
    })();

    const { field } = useController({
        name,
        control,
        defaultValue,
        rules: {
            min,
            max,
            minLength,
            maxLength: mask ? undefined : maxLength,
            required: required ? "msg.osc.00013" : undefined,
            pattern,
            validate: validateMaskedMaxLength,
            onChange: (event) => {
                if (!onChange) return;
                if (!event.target) return;
                onChange(event.target.value);
            },
            onBlur: (event) => {
                if (!onBlur) return;
                if (!event.target) return;
                onBlur(event.target);
            },
        },
    });

    return (
        <>
            {React.cloneElement(children, {
                ...field,
                ...rest,
                maxLength: renderedMaxLength,
            })}
            {window.location.protocol === "https:" && props.edit === false && copy && (
                <button
                    className="hidden absolute left-full top-1/2 -translate-y-1/2 pl-1 py-1 hover:text-gray group-hover/control:block"
                    onClick={(e) => {
                        e.preventDefault();
                        try {
                            window.navigator.clipboard.writeText(field.value || "");
                            showToast({ content: "L_CPY", type: "info" });
                        } catch (error) {}
                    }}
                >
                    <Icon icon="clipboard" size="xs" />
                </button>
            )}
        </>
    );
};
